import React, { useState, useEffect } from "react";

import purchasePic from '../../../../assets/purchase.png'

const PayedPage = () => {
    return(
        <div className="h-screen flex flex-col items-center justify-center -mt-12">
            <img src={purchasePic} alt="frase decorativa de compra" />
            <h1 className="font-playFair font-bold text-4xl">Muchas gracias por tu compra</h1>
            <p className="font-sourceSans text-lg pt-3">Cada vez más cerca de terminar, ¡Tú puedes!</p>
            <a href="/student/tablero" className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-[15%] shadow-lg py-2 mt-12 text-center" type="submit">
                Seguir aprendiendo
            </a>
        </div>
    )
}

export default PayedPage;